var map = {
	"./EchoesofEarth2024-25.ts": [
		48156,
		156
	],
	"./arijit-singh-india-tour.ts": [
		80,
		80
	],
	"./comic-con-india-2024.ts": [
		2287,
		287
	],
	"./independence-rock.ts": [
		3448,
		448
	],
	"./kenny-sebastian-professor-of-tomfoolery-voI-II.ts": [
		83239,
		239
	],
	"./king-monopoly-moves-2024-album-listening-party.ts": [
		32666,
		666
	],
	"./pcrc-goodluckbeta24.ts": [
		92005,
		386
	],
	"./play-for-a-cause-parikrama.ts": [
		42995,
		995
	],
	"./zamna-india-2024.ts": [
		27712,
		712
	],
	"./zamna-india-2025.ts": [
		9615,
		615
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40719;
module.exports = webpackAsyncContext;